import { TextContainer } from 'components/container'
import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

const beforeAfterCss = css`
  content: '';
  position: absolute;
  bottom: 100%;
  left: 0;
  display: block;
  width: 20%;
  height: 8rem;
  mask: linear-gradient(to top, black, transparent);
  pointer-events: none;
  background: var(--background);
  z-index: 1;
`

export const WideImage = styled.figure`
  position: relative;
  margin: 5rem 0;

  ${mq.medium} {
    margin: 8rem 0;
  }

  img,
  video {
    display: block;
    position: relative;
    width: 100%;
    max-height: 100vh;
    object-fit: cover;
    object-position: center bottom;
    z-index: 1;
  }

  ${mq.large} {
    &::before {
      ${beforeAfterCss}
    }
  }
`

export const Figcaption = styled.figcaption`
  position: relative;
  padding-top: 0.2em;
  font-size: 1.4rem;
  z-index: 100;

  ${TextContainer} {
    text-align: center;
  }

  ${mq.large} {
    &::after {
      ${beforeAfterCss}
      bottom: auto;
      top: 0;
      mask: linear-gradient(to bottom, black, transparent);
    }
  }
`

export const StyledVideo = styled.video`
  ${mq.smallOnly} {
    aspect-ratio: 5 / 4;
  }
`
